import React from "react";
import { Trash2 } from "lucide-react";
import { fmtPrice } from "../../../lib/format";
import { inp, lbl } from "../shared";

export function DiscountsTab({ ctx }) {
  const { discounts, newDisc, setNewDisc, addDiscount, delDiscount } = ctx;
  return (
      <div className="max-w-lg">
        <h1 className="serif text-3xl mb-8">Discount Codes</h1>
        <div className="flex flex-wrap gap-3 items-end mb-8">
          <div><label className={lbl}>Code</label><input value={newDisc.code} onChange={(e) => setNewDisc({ ...newDisc, code: e.target.value.toUpperCase() })} data-testid="disc-code" className={inp} /></div>
          <div><label className={lbl}>Type</label><select value={newDisc.type} onChange={(e) => setNewDisc({ ...newDisc, type: e.target.value })} className={inp}><option value="percent">Percent</option><option value="fixed">Fixed</option></select></div>
          <div><label className={lbl}>Value</label><input type="number" value={newDisc.value} onChange={(e) => setNewDisc({ ...newDisc, value: parseFloat(e.target.value) || 0 })} className={inp + " w-24"} /></div>
          <button onClick={addDiscount} data-testid="disc-add" className="bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.2em] px-6 py-2.5 hover:bg-[#E7CBA9]">Add</button>
        </div>
        <div className="border border-[#262421] divide-y divide-[#262421]">
          {discounts.map((d) => (
            <div key={d.code} className="flex items-center justify-between p-4">
              <span className="serif text-lg text-[#C49A6C]">{d.code}</span>
              <span className="text-sm text-[#8A857D]">{d.type === "percent" ? `${d.value}%` : fmtPrice(d.value, "AED")}</span>
              <button onClick={() => delDiscount(d.code)} className="text-[#6E685F] hover:text-[#c88]"><Trash2 size={16} /></button>
            </div>
          ))}
          {discounts.length === 0 && <p className="p-4 text-sm text-[#8A857D]">No discount codes.</p>}
        </div>
      </div>
  );
}
